import ObjectUtils from '../system/ObjectUtils';
Object.compare = ObjectUtils.compare;
Object.convert = ObjectUtils.convert;
Object.deepClone = ObjectUtils.deepClone;
Object.deepEqual = ObjectUtils.deepEqual;
Object.equal = ObjectUtils.equal;
Object.filter = ObjectUtils.filter;
Object.findKey = ObjectUtils.findKey;
Object.findTalue = ObjectUtils.findTalue;
Object.forEach = ObjectUtils.forEach;
Object.isEmpty = ObjectUtils.isEmpty;
Object.isFunction = ObjectUtils.isFunction;
Object.isGreaterThan = ObjectUtils.isGreaterThan;
Object.isGreaterThanOrEqualTo = ObjectUtils.isGreaterThanOrEqualTo;
Object.isIn = ObjectUtils.isIn;
Object.isLessThan = ObjectUtils.isLessThan;
Object.isLessThanOrEqualTo = ObjectUtils.isLessThanOrEqualTo;
Object.isObject = ObjectUtils.isObject;
Object.keyCount = ObjectUtils.keyCount;
Object.setIfAbsent = ObjectUtils.setIfAbsent;
Object.shallowClone = ObjectUtils.shallowClone;
Object.shallowEqual = ObjectUtils.shallowEqual;
Object.shallowMerge = ObjectUtils.shallowMerge;
Object.toArray = ObjectUtils.toArray;
//# sourceMappingURL=ObjectExtensions.js.map